// Salesforce API service - communicates with Cloudflare Pages Functions

export const searchAccounts = async (searchTerm) => {
  try {
    const response = await fetch(`/salesforce-accounts?search=${encodeURIComponent(searchTerm)}`)
    if (!response.ok) {
      const errorData = await response.json()
      console.error('❌ Salesforce API Error Response:', errorData)
      throw new Error(errorData.message || 'Failed to search accounts')
    }
    return await response.json()
  } catch (error) {
    console.error('❌ Salesforce API Error:', error)
    // Show error to user and return empty array
    alert(`Salesforce connection error: ${error.message}\n\nPlease check Cloudflare Pages environment variables.`)
    return []
  }
}

export const getAccountContacts = async (accountId) => {
  try {
    const response = await fetch(`/salesforce-contacts-${accountId}`)
    if (!response.ok) {
      const errorData = await response.json()
      console.error('❌ Salesforce Contacts API Error Response:', errorData)
      throw new Error(errorData.message || 'Failed to get contacts')
    }
    return await response.json()
  } catch (error) {
    console.error('❌ Salesforce Contacts API Error:', error)
    return []
  }
}

// Test function to check if Salesforce API is working
export const testSalesforceConnection = async () => {
  try {
    const response = await fetch('/salesforce-test')
    const data = await response.json()
    console.log('🔍 Salesforce API Test:', data)
    return data
  } catch (error) {
    console.error('❌ Test endpoint error:', error)
    return { error: error.message }
  }
}